import type { FruitPriceWon, FruitProductId, FruitRoundResult } from "../types";

export interface PriceResolutionInput {
  readonly productId: FruitProductId;
  readonly sellerPrices: readonly {
    readonly playerId: string;
    readonly priceWon: FruitPriceWon;
  }[];
  readonly sellerCount: number;
  readonly hidden: boolean;
}

export function resolveProductPricing(
  input: PriceResolutionInput,
): FruitRoundResult | null {
  if (input.sellerPrices.length === 0 || input.sellerCount <= 0) {
    return null;
  }

  const finalPriceWon = input.sellerPrices.reduce<FruitPriceWon>(
    (lowest, sellerPrice) =>
      sellerPrice.priceWon < lowest ? sellerPrice.priceWon : lowest,
    input.sellerPrices[0].priceWon,
  );
  const winnerIds = input.sellerPrices
    .filter((sellerPrice) => sellerPrice.priceWon === finalPriceWon)
    .map((sellerPrice) => sellerPrice.playerId);
  const totalRevenueWon = finalPriceWon * input.sellerCount;
  const payoutWon = Math.floor(totalRevenueWon / winnerIds.length);
  const payoutByPlayerId = Object.fromEntries(
    winnerIds.map((winnerId) => [winnerId, payoutWon]),
  );

  return {
    productId: input.productId,
    sellerCount: input.sellerCount,
    finalPriceWon,
    totalRevenueWon,
    winnerIds,
    payoutByPlayerId,
    hidden: input.hidden,
  };
}
